import 'twin.macro';
import { Layout } from '@auth_module/components/Layout';
import { ResetPasswordForm } from '@auth_module/components/ResetPasswordForm';
import { withTitle } from '@hoc/withTitle';

export const _ResetPasswordPage = () => {
  return (
    <Layout tw='md:top-[calc(50% - 248px)] md:max-w-[480px] p-6 md:p-0'>
      <ResetPasswordForm />
    </Layout>
  );
};

export const ResetPasswordPage = withTitle(_ResetPasswordPage, 'auth.reset_password_page.title');
